import ApiService from "./ApiService"
import appConfig from '../configs/app.config'

export async function getNewReports (data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'getreport',
        method: 'get',
        headers: {
            'Content-Type': 'application/json',
            'start_date': data.start_date,
            'end_date': data.end_date,
            'type': data.type, // json or xlsx
            'report_type': data.report_type, // cooler_availibility , cooler_availibility_kumule , display_availibility , display_availibility_detailed, sign_availibility , shelf_availibility
            // Axios omits boolean false headers; send the literal HTTP header value instead.
            ...(data.report_saved === false ? { 'report_saved': 'false' } : {}),
        },
        data,
        responseType: data.type === 'xlsx' ? 'arraybuffer' : 'json'
    })
}

export async function getDistileReports (data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'getdistilereport',
        method: 'get',
        headers: {
            'Content-Type': 'application/json',
            'start_date': data.date,
            'type': data.type,
            'category': encodeURIComponent(data.category)
        },
        data,
        responseType: data.type === 'xlsx' ? 'arraybuffer' : 'json'
    })
}

export async function getPosmExistenceList (data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'getposmexistenceresultsnew',
        method: 'get',
        headers: {'Content-Type' : 'application/json'},
        responseType: data.type === 'xlsx' ? 'arraybuffer' : 'json',
        params: {
            date: data.date,
            type: data.type
        }
    })
}


export async function getDinamikPlanogram (data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'getdynplanavailresults',
        method: 'get',
        headers: {'Content-Type' : 'application/json'},
        responseType: data.type === 'xlsx' ? 'arraybuffer' : 'json',
        params: {
            start_date: data.start_date,
            end_date: data.end_date
        }
    })
}

export async function getReports (data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'mobreportnew',
        method: 'get',
        headers: {'Content-Type' : 'application/json'},
        data
    })
}


// Temsilci Ziyaret İstatistiklerini döndürür
export async function getTransactionsSSM (data) {
    return ApiService.fetchData({
        url: 'https://nosimia.com.tr/efes/servis',
        method: 'post',
        headers: {'Content-Type' : 'application/json'},
        data
    })
}

// KPI Skorları döndürür
export async function getKpiScoreVisits (data) {
    return ApiService.fetchData({
        url: 'https://nosimia.com.tr/efes/servis',
        method: 'post',
        headers: {'Content-Type' : 'application/json'},
        data
    })
}

// Genel Raporları Döndürür
export async function getGeneralReports (data) {
    return ApiService.fetchData({
        url: 'https://nosimia.com.tr/efes/servis',
        method: 'post',
        headers: {'Content-Type' : 'application/json'},
        data
    })
}

// Genel Servis istekleri için kullanılır
export async function getVariableService (data) {
    return ApiService.fetchData({
        url: 'https://nosimia.com.tr/efes/servis',
        method: 'post',
        headers: {'Content-Type' : 'application/json'},
        data
    })
}

// Genel Servis istekleri için kullanılır
export async function getVariableServiceMaster (data) {
    return ApiService.fetchData({
        url: 'https://nosimia.com.tr/efes/testjson',
        method: 'get',
        headers: {'Content-Type' : 'application/json'},
        data
    })
}

export async function getKPIscoreTrends (params) {
    return ApiService.fetchData({
        url: '/stats/kpi_trends',
        method: 'get',
        params
    })
}


export async function getKPIscorePer (params) {
    return ApiService.fetchData({
        url: '/stats/kpi_per',
        method: 'get',
        params
    })
}

// Log servisi - Hata durumlarında log gönderir
export async function setErrorLog (logData) {
    return ApiService.fetchData({
        url: 'https://felogger.neocortexbe.com:65014/setlog',
        method: 'post',
        headers: {
            'Content-Type': 'application/json',
            'Secret-Key': 'dByGUfNG5DJTZwE'
        },
        data: logData
    }).catch(error => {
        // Log gönderme hatası durumunda sessizce başarısız ol, ana işlemi engelleme
        console.error('Log servisi hatası:', error)
        return Promise.resolve()
    })
}
